export default __webpack_public_path__ + "static/media/car-white.07242aa2.jpg";